export {
  VALIDATION_REQUIRED,
  LABEL_PT,
  LABEL_ES,
  LABEL_EN,
  LABEL_FR,
  LABEL_DE,
  LABEL_IT,
  PREFFIX_CLIENT,
  PREFFIX_AGE,
  SON_OPTION,
  DAUGHTER_OPTION,
  OTHER_OPTION,
  VALIDATION_MUST_BE_UNDER_18,
  VALIDATION_MUST_BE_THAN_18,
  VALIDATION_VALID_DATE,
} from '../../shared/constants/locale';

export const TITLE = {
  en_US: 'PATIENT',
  it_IT: 'PAZIENTE',
  pt_BR: 'PACIENTE',
  es_ES: 'PACIENTE',
  de_DE: 'PATIENT/IN',
  fr_FR: 'PATIENT',
};

export const SUBTITLE_NEED_HELP = {
  en_US: 'Who needs help today?',
  it_IT: 'Chi ha bisogno di aiuto oggi?',
  pt_BR: 'Quem precisa de ajuda hoje?',
  es_ES: '¿Quién necesita ayuda hoy?',
  de_DE: 'Wem dürfen wir heute helfen?',
  fr_FR: 'Pour qui est la consultation ?',
};

export const NEXT_BUTTON = {
  en_US: 'NEXT',
  it_IT: 'AVANTI',
  pt_BR: 'PRÓXIMO',
  es_ES: 'SIGUIENTE',
  de_DE: 'WEITER',
  fr_FR: 'SUIVANT',
};

export const BACK_BUTTON = {
  en_US: 'BACK',
  it_IT: 'PRECEDENTE',
  pt_BR: 'VOLTAR',
  es_ES: 'ATRÁS',
  de_DE: 'ZURÜCK',
  fr_FR: 'RETOUR',
};

export const FAMILY_MEMBER = {
  en_US: 'Minor dependents',
  it_IT: 'Dependenti minori a carico',
  pt_BR: 'Dependentes menores de idade',
  es_ES: 'Dependientes menores de edad',
  de_DE: 'Minderjährige Familienangehörige',
  fr_FR: 'Personnes à charge mineures',
};

export const ADULT_BENEFICIARY = {
  en_US: 'Other adult beneficiary',
  it_IT: 'Altro beneficiario adulto',
  pt_BR: 'Outro beneficiário adulto',
  es_ES: 'Otro beneficiario adulto',
  de_DE: 'Anderer erwachsener Begünstigter',
  fr_FR: 'Autre bénéficiaire adulte',
};

export const ADD_NEW_BUTTON = {
  en_US: '+ ADD NEW',
  it_IT: '+ AGGIUNGI NUOVO',
  pt_BR: '+ ADICIONAR NOVO',
  es_ES: '+ AGREGAR NUEVO',
  de_DE: '+ NEU HINZUFÜGEN',
  fr_FR: '+ AJOUTER',
};

export const CONTINUE_BUTTON = {
  en_US: 'CONTINUE',
  it_IT: 'CONTINUA',
  pt_BR: 'CONTINUAR',
  es_ES: 'CONTINUAR',
  de_DE: 'WEITER',
  fr_FR: 'CONTINUER',
};

export const SELECT_PATIENT = {
  en_US: 'Select patient',
  it_IT: 'Seleziona il paziente',
  pt_BR: 'Selecione o paciente',
  es_ES: 'Seleccione un paciente',
  de_DE: 'Patient auswählen',
  fr_FR: 'Sélectionnez un patient',
};
